import { memo } from "react";
import RowActionButton from "../shared/RowActionButton";
import { RowActionWrapper } from "./style";
import { GetAccount200ResponsePositionsInner } from "../../codegen-api";
import { getPositionIdentity } from "../../utils/positionIdentity";
import { FeatureFlagKey, isFeatureEnabled } from "../../config/features";

interface IActionButtonsCellProps {
  shareColor: string;
  inLiquidation: boolean;
  position: GetAccount200ResponsePositionsInner;
  onClosePositionWithId: (instrumentId: string) => void;
  setViewDetailsForPositionId: (instrumentId: string) => void;
  setShareModalPositionId: (instrumentId: string) => void;
  setAdjustingMarginPositionId: (instrumentId: string) => void;
}

function ActionButtonsCell({
  inLiquidation,
  shareColor,
  position,
  onClosePositionWithId,
  setViewDetailsForPositionId,
  setShareModalPositionId,
  setAdjustingMarginPositionId,
}: IActionButtonsCellProps) {
  const positionId = getPositionIdentity(position) || position.instrument_id;

  return (
    <RowActionWrapper>
      {!!position.isolated_margin &&
        isFeatureEnabled(FeatureFlagKey.ISOLATED_MARGIN_ADJUST) && (
        <RowActionButton
          variant={"edit"}
          onClick={(e) => {
            e.stopPropagation();
            setAdjustingMarginPositionId(positionId);
          }}
        />
      )}
      {!inLiquidation && (
        <RowActionButton
          variant={"close"}
          onClick={() => {
            onClosePositionWithId(positionId);
          }}
        />
      )}
      <RowActionButton
        variant={"details"}
        onClick={() => {
          setViewDetailsForPositionId(positionId);
        }}
      />
      <RowActionButton
        variant="share"
        svgColor={shareColor}
        onClick={() => {
          setShareModalPositionId(positionId);
        }}
      />
    </RowActionWrapper>
  );
}

export default memo(ActionButtonsCell);
